import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileUser: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.75 6V3.75L19.25 8.25H17C15.42 8.25 14.75 7.58 14.75 6ZM20 9.75V18C20 20 19 21 17 21H8C6 21 5 20 5 18V6C5 4 6 3 8 3H13.25V6C13.25 8.42 14.58 9.75 17 9.75H20ZM10.3501 12.15C10.3501 13.336 11.315 14.3 12.5 14.3C13.685 14.3 14.6499 13.335 14.6499 12.15C14.6499 10.965 13.685 10 12.5 10C11.315 10 10.3501 10.964 10.3501 12.15ZM16 18.197C16 16.857 15.0191 15.5 13.1421 15.5H11.8589C9.98189 15.5 9.00098 16.857 9.00098 18.197V18.5C9.00098 18.776 9.22498 19 9.50098 19H15.501C15.777 19 16.001 18.776 16.001 18.5V18.197H16Z" fill={color} />
  </svg>
);

export default IconFileUser;
